import { useAppSelector } from "../../../../store/hooks";
import { shallowEqual } from "react-redux";
import { WorkloadInput } from "../../../../schema/types/workload/input";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";

export function useScratchSuggestions(containerIndex: number, volumeIndex: number) {
  const { id } = useCpFormContext();
  return useAppSelector((state) => {
    const values: WorkloadInput = state.form.instances[id].values as any;

    const containers = values.containers;

    const volume = containers[containerIndex]?.volumes[volumeIndex];
    if (!volume || volume.uriType !== "scratch://") {
      return [];
    }

    let res: string[] = [];
    for (const _containerIndexStr in containers) {
      const _containerIndex = Number(_containerIndexStr);
      const container = containers[_containerIndex];
      for (const _volumeIndexStr in container.volumes) {
        const _volumeIndex = Number(_volumeIndexStr);
        if (_volumeIndex === volumeIndex && _containerIndex === containerIndex) {
          continue;
        }
        const _volume = container.volumes[_volumeIndex];
        if (_volume.uriType !== "scratch://" || !_volume.scratch || res.includes(_volume.scratch)) {
          continue;
        }
        res.push(_volume.scratch);
      }
    }
    return res;
  }, shallowEqual);
}
